var _excluded = ["defaultText", "submittingText", "submitting", "icon"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import Button from "./Button";
import LoadingIcon from "./LoadingIcon";
import { forwardInnerRef } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

function SubmitButton(_ref) {
  var _ref$defaultText = _ref.defaultText,
      defaultText = _ref$defaultText === void 0 ? "Submit" : _ref$defaultText,
      _ref$submittingText = _ref.submittingText,
      submittingText = _ref$submittingText === void 0 ? "Submitting" : _ref$submittingText,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      icon = _ref.icon,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return ___EmotionJSX(Button, _extends({}, props, {
    loading: submitting,
    type: "submit",
    icon: submitting ? ___EmotionJSX(LoadingIcon, null) : icon
  }), submitting ? submittingText + "\u2026" : defaultText);
}

var SubmitButtonWithRef = forwardInnerRef(SubmitButton);
export default SubmitButtonWithRef;